import { Injectable } from '@angular/core';
import { UserAuthentified } from '@app/authentification/user-authentified.interface';
import { PageHeaderMenu } from '@app/components/pr-page/pr-page-header-menu/pr-page-header-menu.component';
import {
  ProductInfo,
  ProductQuestionDetail,
  ProductsTypeEnum,
  Question,
} from '@app/forms/subscription/definition/interface';
import { Memoize } from '@app/providers/utils/memoize-decorator';
import { QuestionsDataService } from './questions/questions-data.service';

@Injectable({
  providedIn: 'root',
})
export class InMemoryDataService {
  constructor(private questionsDataService: QuestionsDataService) {}

  productsType = {
    SCPI: 'SCPI',
    PER: 'PER',
    ASSURANCE_VIE: 'assurance vie',
    FCPI: 'FCPI',
    FPCI: 'FPCI',
    BOND: 'Fonds Obligataires',
    GFV: 'Groupement foncier viticole',
    GFI: 'Groupements Forestiers d’Investissement',
    GFF: 'Groupement Foncier Forestier',
    TITRES_PARTICIPATIFS: 'Titres Participatifs',
    SOCIAL_SHARE: 'Parts Sociales',
    OBLIGATIONS: 'Obligations',
    DIVERSIFICATION_INVESTMENT: 'Investissement de diversification',
    COMPTE_TITRE: 'Compte Titre',
    PEA: 'PEA',
    CONTRAT_CAPI: 'Contrat de capitalisation',
    CONTINGENCY: 'Prévoyance',
    INSURANCE: 'Mutuelle',
    PEI: 'PEI',
    PEE: 'PEE',
    PERCO: 'PERCO',
    FIP: 'FIP',
    FIP_DOMTOM: 'FIP DOM-TOM',
    FIP_CORSE: 'FIP Corse',
    FCPR: 'FCPR',
    FPS: 'FPS',
    GIRARDIN: 'GIRARDIN',
    INVESTISSEMENT_PME: 'INVESTISSEMENT PME',
    SOFICA: 'SOFICA',
    TANGIBLES: 'TANGIBLES',
    CROWDFUNDING: 'CROWDFUNDING',
    DEFISCALISATION: 'DEFISCALISATION',
    PRIVATE_EQUITY: 'Private Equity',
    LMNP: 'Immobilier meublé',
    UNFURNISHED: 'Immobilier non meublé',
    CAT: 'Compte à terme',
    BORROWER_INSURANCE: 'Assurance emprunteur',
    PRESTATION: 'Kit fiscal',
  };
  productTypes: ProductInfo[] = [
    { id: 1, name: ProductsTypeEnum.SCPI, label: this.productsType.SCPI },
    { id: 2, name: ProductsTypeEnum.PER, label: this.productsType.PER },
    {
      id: 3,
      name: ProductsTypeEnum.ASSURANCE_VIE,
      label: this.productsType.ASSURANCE_VIE,
    },
    { id: 4, name: ProductsTypeEnum.FCPI, label: this.productsType.FCPI },
    { id: 5, name: ProductsTypeEnum.FIP, label: this.productsType.FIP },
    {
      id: 6,
      name: ProductsTypeEnum.GIRARDIN,
      label: this.productsType.GIRARDIN,
    },
    {
      id: 7,
      name: ProductsTypeEnum.INVESTISSEMENT_PME,
      label: this.productsType.INVESTISSEMENT_PME,
    },
    { id: 8, name: ProductsTypeEnum.SOFICA, label: this.productsType.SOFICA },
    {
      id: 9,
      name: ProductsTypeEnum.TANGIBLES,
      label: this.productsType.TANGIBLES,
    },
    {
      id: 10,
      name: ProductsTypeEnum.CROWDFUNDING,
      label: this.productsType.CROWDFUNDING,
    },
    {
      id: 11,
      name: ProductsTypeEnum.DEFISCALISATION,
      label: this.productsType.DEFISCALISATION,
    },
    {
      id: 12,
      name: ProductsTypeEnum.PRIVATE_EQUITY,
      label: this.productsType.PRIVATE_EQUITY,
    },
    {
      id: 13,
      name: ProductsTypeEnum.LMNP,
      label: this.productsType.LMNP,
    },
    {
      id: 14,
      name: ProductsTypeEnum.UNFURNISHED,
      label: this.productsType.UNFURNISHED,
    },
    {
      id: 15,
      name: ProductsTypeEnum.CAT,
      label: this.productsType.CAT,
    },
    {
      id: 16,
      name: ProductsTypeEnum.PRESTATION,
      label: this.productsType.PRESTATION,
    },
    {
      id: 17,
      name: ProductsTypeEnum.FCPR,
      label: this.productsType.FCPR,
    },
    {
      id: 18,
      name: ProductsTypeEnum.FPCI,
      label: this.productsType.FPCI,
    },
    {
      id: 19,
      name: ProductsTypeEnum.BOND,
      label: this.productsType.BOND,
    },
    {
      id: 20,
      name: ProductsTypeEnum.CONTRAT_CAPI,
      label: this.productsType.CONTRAT_CAPI,
    },
    {
      id: 21,
      name: ProductsTypeEnum.COMPTE_TITRE,
      label: this.productsType.COMPTE_TITRE,
    },
    {
      id: 22,
      name: ProductsTypeEnum.TITRES_PARTICIPATIFS,
      label: this.productsType.TITRES_PARTICIPATIFS,
    },
    {
      id: 23,
      name: ProductsTypeEnum.PEE,
      label: this.productsType.PEE,
    },
    {
      id: 24,
      name: ProductsTypeEnum.PERCO,
      label: this.productsType.PERCO,
    },
    {
      id: 25,
      name: ProductsTypeEnum.BORROWER_INSURANCE,
      label: this.productsType.BORROWER_INSURANCE,
    },
    {
      id: 26,
      name: ProductsTypeEnum.GFV,
      label: this.productsType.GFV,
    },
    {
      id: 27,
      name: ProductsTypeEnum.GFF,
      label: this.productsType.GFF,
    },
    {
      id: 28,
      name: ProductsTypeEnum.GFI,
      label: this.productsType.GFI,
    },
    {
      id: 29,
      name: ProductsTypeEnum.PEI,
      label: this.productsType.PEI,
    },
    {
      id: 30,
      name: ProductsTypeEnum.DIVERSIFICATION_INVESTMENT,
      label: this.productsType.DIVERSIFICATION_INVESTMENT,
    },
    {
      id: 31,
      name: ProductsTypeEnum.FIP_CORSE,
      label: this.productsType.FIP_CORSE,
    },
    {
      id: 32,
      name: ProductsTypeEnum.FIP_DOMTOM,
      label: this.productsType.FIP_DOMTOM,
    },
    {
      id: 33,
      name: ProductsTypeEnum.CONTINGENCY,
      label: this.productsType.CONTINGENCY,
    },
    {
      id: 38,
      name: ProductsTypeEnum.INSURANCE,
      label: this.productsType.INSURANCE,
    },
    {
      id: 34,
      name: ProductsTypeEnum.FPS,
      label: this.productsType.FPS,
    },
    {
      id: 35,
      name: ProductsTypeEnum.PEA,
      label: this.productsType.PEA,
    },
    {
      id: 36,
      name: ProductsTypeEnum.OBLIGATIONS,
      label: this.productsType.OBLIGATIONS,
    },
    {
      id: 37,
      name: ProductsTypeEnum.SOCIAL_SHARE,
      label: this.productsType.SOCIAL_SHARE,
    },
  ];
  questionsSubscription: Question[] = [
    ...this.questionsDataService.civilstatusQustions,
    ...this.questionsDataService.riskProfileQustions,
    ...this.questionsDataService.financialKnowledgeQustions,
    ...this.questionsDataService.resultTailoredQustions,
  ];
  questions: Question[] = [
    ...this.questionsSubscription.map((item, index) => {
      return {
        ...item,
        id: index,
      };
    }),
  ];
  /**
   *  get the questionsIds from the questions array with parammetes excluded (excludedQuestions)
   *
   */
  getQuestionsIds(excludedQuestions: (string | number)[] = []) {
    return this.questions
      .filter(question => {
        return !excludedQuestions.includes(question.id);
      })
      .map(question => {
        return question.id;
      });
  }

  getQuestionsByProductType(
    type: keyof typeof ProductsTypeEnum,
    excludedQuestionNames: string[] = [],
  ) {
    return this.questions
      .filter(question => {
        return (
          (question.productType.includes(type) ||
            !question.productType.length) &&
          !excludedQuestionNames.includes(question.name)
        );
      })
      .map(question => {
        return question.id;
      });
  }

  questionIdsStandard: (string | number)[] = [
    ...this.getQuestionsIds([35, 36, 37, 38, 39, 40, 42, 59]),
  ];
  questionIdsAssuranceVie: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.ASSURANCE_VIE),
  ];

  questionIdsSCPIStandard: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.SCPI),
  ];
  questionIdsGirardin: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.GIRARDIN),
  ];
  questionIdsCrowdfunding: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.CROWDFUNDING),
  ];
  questionIdsPer: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.PER),
  ];
  questionIdsPrivateEquity: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.PRIVATE_EQUITY),
  ];
  questionIdsFcpi: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.FCPI),
  ];
  questionIdsFip: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.FIP),
  ];
  questionIdsLMNP: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.LMNP),
  ];
  questionIdsUnfurnished: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.UNFURNISHED),
  ];
  questionIdsCat: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.CAT),
  ];
  questionIdsPrestation: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.PRESTATION),
  ];
  questionIdsFCPR: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.FCPR),
  ];
  questionIdsFpci: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.FPCI),
  ];
  questionIdsBond: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.BOND),
  ];
  questionsIdsContratCapi: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.CONTRAT_CAPI),
  ];
  questionIdsCompteTitre: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.COMPTE_TITRE),
  ];
  questionIdsTitresParticipatifs: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.TITRES_PARTICIPATIFS),
  ];
  questionIdsPeec: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.PEE),
  ];
  questionIdsPerco: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.PERCO),
  ];
  questionIdsBorrowerInsurance: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.BORROWER_INSURANCE),
  ];
  questionIdsGfv: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.GFV),
  ];
  questionIdsGff: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.GFF),
  ];
  questionIdsGfi: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.GFI),
  ];
  questionIdsPei: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.PEI),
  ];
  questionIdsDiversificationInvestment: (string | number)[] = [
    ...this.getQuestionsByProductType(
      ProductsTypeEnum.DIVERSIFICATION_INVESTMENT,
    ),
  ];
  questionIdsFipCorse: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.FIP_CORSE),
  ];
  questionIdsFipDomTom: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.FIP_DOMTOM),
  ];
  /**
   * Questions d'investissement exclues pour la prevoyance (CONTINGENCY).
   * La prevoyance est un produit d'assurance/protection, pas un investissement.
   * Ces questions evaluent le profil investisseur et ne sont pas pertinentes.
   */
  private readonly contingencyExcludedQuestions: string[] = [
    // Connaissances financieres (profil investisseur — non pertinent pour la prevoyance)
    'riskProfilFirstPartForm',
    'riskProfilCompanyFirstPartForm',
    'riskProfilSecondPartForm',
    'riskProfilCompanySecondPartForm',
    'riskProfilThirdPartForm',
    'riskProfilFourthPartForm',
    'riskProfilCompanyFourthPartForm',
    'riskProfilFifthPartForm',
    'existingInvestments',
    'savingsRate',
    'moneyGames',
    'investmentKnowledge',
    'financialKnowledge1',
    'investmentObjective',
    'fundsInitialPayment',
    'justificatifOrigineDesFonds',
    // Profil patrimonial (patrimoine/epargne/ESG — non pertinent, les revenus et profession
    // sont captures dans contigency-regime-profession)
    'profilePage',
    'assessmentAssetsIncome',
    'profession',
    'assessmentAssets',
    'assessmentAssetsOrigin',
    'loanRepartitionForm',
    'principalResidence',
    'savingsCapacity',
    'investmentObjectiveHeritage',
    'esgSituation',
    'taxonomy',
    'esgInvestmentList',
    'esgInvestmentSituation',
    'investmentHorizon',
    // Composition du contrat (duree d'investissement — non pertinent pour la prevoyance)
    'investmentDuration',
  ];

  questionIdsContigency: (string | number)[] = [
    ...this.getQuestionsByProductType(
      ProductsTypeEnum.CONTINGENCY,
      this.contingencyExcludedQuestions,
    ),
  ];
  /**
   * Questions exclues pour la mutuelle (INSURANCE).
   * Meme logique que la prevoyance : pas un produit d'investissement.
   */
  questionIdsInsurance: (string | number)[] = [
    ...this.getQuestionsByProductType(
      ProductsTypeEnum.INSURANCE,
      this.contingencyExcludedQuestions,
    ),
  ];
  questionIdsFps: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.FPS),
  ];
  questionIdsPea: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.PEA),
  ];
  questionIdsObligations: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.OBLIGATIONS),
  ];
  questionIdsSocialShare: (string | number)[] = [
    ...this.getQuestionsByProductType(ProductsTypeEnum.SOCIAL_SHARE),
  ];

  product: ProductQuestionDetail[] = [
    {
      id: 1,
      name: ProductsTypeEnum.SCPI,

      questionIds: [...this.questionIdsSCPIStandard],
    },
    {
      id: 2,
      name: ProductsTypeEnum.PER,
      questionIds: [...this.questionIdsPer],
    },
    {
      id: 3,
      name: ProductsTypeEnum.ASSURANCE_VIE,
      questionIds: [...this.questionIdsAssuranceVie],
    },
    {
      id: 4,
      name: ProductsTypeEnum.FCPI,
      questionIds: [...this.questionIdsFcpi],
    },
    {
      id: 5,
      name: ProductsTypeEnum.FIP,
      questionIds: [...this.questionIdsFip],
    },
    {
      id: 6,
      name: ProductsTypeEnum.GIRARDIN,
      questionIds: [...this.questionIdsGirardin],
    },
    {
      id: 7,
      name: ProductsTypeEnum.INVESTISSEMENT_PME,
      questionIds: [...this.questionIdsStandard],
    },
    {
      id: 8,
      name: ProductsTypeEnum.SOFICA,
      questionIds: [...this.questionIdsStandard],
    },
    {
      id: 9,
      name: ProductsTypeEnum.TANGIBLES,
      questionIds: [...this.questionIdsStandard],
    },
    {
      id: 10,
      name: ProductsTypeEnum.CROWDFUNDING,
      questionIds: [...this.questionIdsCrowdfunding],
    },
    {
      id: 11,
      name: ProductsTypeEnum.DEFISCALISATION,
      questionIds: [...this.questionIdsStandard],
    },
    {
      id: 12,
      name: ProductsTypeEnum.PRIVATE_EQUITY,
      questionIds: [...this.questionIdsPrivateEquity],
    },
    {
      id: 13,
      name: ProductsTypeEnum.LMNP,
      questionIds: [...this.questionIdsLMNP],
    },
    {
      id: 14,
      name: ProductsTypeEnum.UNFURNISHED,
      questionIds: [...this.questionIdsUnfurnished],
    },
    {
      id: 15,
      name: ProductsTypeEnum.CAT,
      questionIds: [...this.questionIdsCat],
    },
    {
      id: 16,
      name: ProductsTypeEnum.PRESTATION,
      questionIds: [...this.questionIdsPrestation],
    },
    {
      id: 17,
      name: ProductsTypeEnum.FCPR,
      questionIds: [...this.questionIdsFCPR],
    },
    {
      id: 18,
      name: ProductsTypeEnum.FPCI,
      questionIds: [...this.questionIdsFpci],
    },
    {
      id: 19,
      name: ProductsTypeEnum.BOND,
      questionIds: [...this.questionIdsBond],
    },
    {
      id: 20,
      name: ProductsTypeEnum.CONTRAT_CAPI,
      questionIds: [...this.questionsIdsContratCapi],
    },
    {
      id: 21,
      name: ProductsTypeEnum.COMPTE_TITRE,
      questionIds: [...this.questionIdsCompteTitre],
    },
    {
      id: 22,
      name: ProductsTypeEnum.TITRES_PARTICIPATIFS,
      questionIds: [...this.questionIdsTitresParticipatifs],
    },
    {
      id: 23,
      name: ProductsTypeEnum.PEE,
      questionIds: [...this.questionIdsPeec],
    },
    {
      id: 24,
      name: ProductsTypeEnum.PERCO,
      questionIds: [...this.questionIdsPerco],
    },
    {
      id: 25,
      name: ProductsTypeEnum.BORROWER_INSURANCE,
      questionIds: [...this.questionIdsBorrowerInsurance],
    },
    {
      id: 26,
      name: ProductsTypeEnum.GFV,
      questionIds: [...this.questionIdsGfv],
    },
    {
      id: 27,
      name: ProductsTypeEnum.GFF,
      questionIds: [...this.questionIdsGff],
    },
    {
      id: 28,
      name: ProductsTypeEnum.GFI,
      questionIds: [...this.questionIdsGfi],
    },
    {
      id: 29,
      name: ProductsTypeEnum.PEI,
      questionIds: [...this.questionIdsPei],
    },
    {
      id: 30,
      name: ProductsTypeEnum.DIVERSIFICATION_INVESTMENT,
      questionIds: [...this.questionIdsDiversificationInvestment],
    },
    {
      id: 31,
      name: ProductsTypeEnum.FIP_CORSE,
      questionIds: [...this.questionIdsFipCorse],
    },
    {
      id: 32,
      name: ProductsTypeEnum.FIP_DOMTOM,
      questionIds: [...this.questionIdsFipDomTom],
    },
    {
      id: 33,
      name: ProductsTypeEnum.CONTINGENCY,
      questionIds: [...this.questionIdsContigency],
    },
    {
      id: 38,
      name: ProductsTypeEnum.INSURANCE,
      questionIds: [...this.questionIdsInsurance],
    },
    {
      id: 34,
      name: ProductsTypeEnum.FPS,
      questionIds: [...this.questionIdsFps],
    },
    {
      id: 35,
      name: ProductsTypeEnum.PEA,
      questionIds: [...this.questionIdsPea],
    },
    {
      id: 36,
      name: ProductsTypeEnum.OBLIGATIONS,
      questionIds: [...this.questionIdsObligations],
    },
    {
      id: 37,
      name: ProductsTypeEnum.SOCIAL_SHARE,
      questionIds: [...this.questionIdsSocialShare],
    },
  ];

  getProductTypeById(id: number): ProductInfo {
    return this.productTypes.find(productType => productType.id === id);
  }

  getQuestionById(id: string | number): Question {
    return this.questions.find(question => question.id === id);
  }

  getQuestionByStep(step: string): Question {
    return this.questions.find(question => question?.step == step);
  }

  getQuestionsByCategory(category: string): Question[] {
    return this.questions.filter(question => question.category === category);
  }

  getQuestionByStepAndId(step: string, id: number): Question {
    return this.questions.find(
      question => question?.id === id && question?.step === step,
    );
  }

  toUpperCase(label: string, exclude: string[] = []): string {
    const words = label.split(' ');
    const result = words.map(word => {
      if (exclude.includes(word)) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    return result.join(' ');
  }

  getMenu(): PageHeaderMenu {
    const allowedProductTypes: ProductsTypeEnum[] = [
      ProductsTypeEnum.SCPI,
      ProductsTypeEnum.ASSURANCE_VIE,
      ProductsTypeEnum.GIRARDIN,
      ProductsTypeEnum.CROWDFUNDING,
      ProductsTypeEnum.PER,
      ProductsTypeEnum.PRIVATE_EQUITY,
      ProductsTypeEnum.FCPI,
      ProductsTypeEnum.FPCI,
      ProductsTypeEnum.BOND,
      ProductsTypeEnum.GFV,
      ProductsTypeEnum.GFI,
      ProductsTypeEnum.CONTINGENCY,
      ProductsTypeEnum.GFF,
      ProductsTypeEnum.COMPTE_TITRE,
      ProductsTypeEnum.PEA,
      ProductsTypeEnum.CONTRAT_CAPI,
      ProductsTypeEnum.PEI,
      ProductsTypeEnum.FIP,
      ProductsTypeEnum.FIP_CORSE,
      ProductsTypeEnum.FIP_DOMTOM,
      ProductsTypeEnum.LMNP,
      ProductsTypeEnum.UNFURNISHED,
      ProductsTypeEnum.CAT,
      ProductsTypeEnum.PRESTATION,
      ProductsTypeEnum.FCPR,
      ProductsTypeEnum.FPS,
      ProductsTypeEnum.TITRES_PARTICIPATIFS,
      ProductsTypeEnum.SOCIAL_SHARE,
      ProductsTypeEnum.OBLIGATIONS,
      ProductsTypeEnum.DIVERSIFICATION_INVESTMENT,
      ProductsTypeEnum.PERCO,
      ProductsTypeEnum.PEE,
      ProductsTypeEnum.BORROWER_INSURANCE,
      ProductsTypeEnum.INSURANCE,
    ];
    const productTypeMenu = this.productTypes
      // -- remove this to allow subscription for all product types --
      .filter(productType => allowedProductTypes.includes(productType.name))
      // ----
      .map(productType => {
        return {
          label: productType.name,
          text: this.toUpperCase(productType.label, [
            this.productsType.FCPI,
            this.productsType.FIP,
            this.productsType.FIP_CORSE,
            this.productsType.FIP_DOMTOM,
            this.productsType.LMNP,
            this.productsType.PER,
            this.productsType.FPCI,
            this.productsType.BOND,
            this.productsType.GFV,
            this.productsType.GFI,
            this.productsType.CONTINGENCY,
            this.productsType.GFF,
            this.productsType.COMPTE_TITRE,
            this.productsType.PEA,
            this.productsType.TITRES_PARTICIPATIFS,
            this.productsType.SOCIAL_SHARE,
            this.productsType.OBLIGATIONS,
            this.productsType.DIVERSIFICATION_INVESTMENT,
          ]),

          url: `../${productType.id}`,
          current: false,
          productName: productType.name,
        };
      });
    return {
      label: 'Product',
      items: productTypeMenu,
    };
  }

  getProductQuestions(productTypeId: number): Question[] {
    const questionIds = this.product.find(
      productQuestion => productQuestion.id === productTypeId,
    ).questionIds;
    const questions = [];
    questionIds.forEach(questionId => {
      questions.push(this.getQuestionById(questionId));
    });

    return questions;
  }

  @Memoize()
  getProductQuestionsByName(productName: string): Question[] {
    const productType = this.product.find(
      product => product.name === productName,
    ).questionIds;
    const questions = [];
    productType.forEach(questionId => {
      questions.push(this.getQuestionById(questionId));
    });
    return questions;
  }

  // get consultant questions
  //  @Memoize()
  getConsultantQuestions({
    product,
    entity,
    user = undefined,
  }: {
    product: string;
    entity;
    user: UserAuthentified;
  }): Question[] {
    const questions = this.getProductQuestionsByName(product);
    // isConsultant n'est qu'un gate de rôle (cf. getClientQuestions : !q.isConsultant) et ne doit
    // jamais court-circuiter alwaysShow/callbackBasedOn — sinon une Question isConsultant avec un
    // callbackBasedOn (ex. les 4 slides "Taux par support" par opération) s'affiche toujours, quel
    // que soit son propre callbackBasedOn (cf. bug PRE-4906 : plusieurs slides "Taux par support"
    // affichées simultanément dans un funnel souscription).
    return questions.filter(
      q =>
        (q.alwaysShow && !!q.alwaysShow(entity, user)) ||
        ((!q?.callbackValidation || !q?.callbackValidation(entity, user)) &&
          (!q?.callbackBasedOn || !q?.callbackBasedOn(entity, user)) &&
          !q.alwaysSkip),
    );
  }
  getConsultantQuestionsFirstTime({
    product,
    entity,
    user = undefined,
  }: {
    product: string;
    entity;
    user: UserAuthentified;
  }): Question[] {
    const questions = this.getProductQuestionsByName(product);
    // Cf. getConsultantQuestions : isConsultant est un gate de rôle, pas un raccourci de visibilité.
    return questions.filter(
      q =>
        (q.alwaysShow && !!q.alwaysShow(entity, user)) ||
        q.showFirstTime ||
        (q?.callbackConsultant && !q?.callbackConsultant(entity)) ||
        ((!q.callbackValidation || !q.callbackValidation(entity, user)) &&
          (!q.callbackBasedOn || !q.callbackBasedOn(entity, user)) &&
          !q.alwaysSkip),
    );
  }
  getClientQuestions({
    product,
    entity,
    user = undefined,
  }: {
    product: string;
    entity;
    user?: UserAuthentified;
  }): Question[] {
    const questions = this.getProductQuestionsByName(product);
    return questions.filter(
      q =>
        !q.isConsultant &&
        ((q.alwaysShow && !!q.alwaysShow(entity, user)) ||
          !q.callbackBasedOn ||
          !q.callbackBasedOn(entity, user)),
    );
  }
}
